export type MenuAnchor = "top-left" | "top-right" | "bottom-left";

/** Positionsklassen der schwebenden Menü-Karte relativ zum `relative`-Anker-Wrapper. */
export function menuAnchorPosition(anchor: MenuAnchor): string {
  switch (anchor) {
    case "top-left": return "top-full left-0 mt-0";
    case "top-right": return "top-full right-0 mt-0";
    case "bottom-left": return "bottom-full left-0 mb-0";
  }
}

/**
 * Rundung nur an der freien Innen-Ecke (diagonal zum Anker); alle kantenberührenden
 * Ecken bleiben eckig, damit die Karte bündig „aus der Kante wächst". Kombiniert mit
 * `rounded-none` als Basis. Theme-Radius (+2px wie die übrigen Popups).
 */
export function menuAnchorRadius(anchor: MenuAnchor): string {
  switch (anchor) {
    case "top-left": return "rounded-br-[calc(var(--radius)+2px)]";
    case "top-right": return "rounded-bl-[calc(var(--radius)+2px)]";
    case "bottom-left": return "rounded-tr-[calc(var(--radius)+2px)]";
  }
}
